import type { Optional } from '@festina-life/core'
import { type ReactNode, useState } from 'react'

import { Provider } from './fPlusScopeFilterValueContext'

type Props = {
  children: ReactNode
}

const FPlusScopeFilterValueProvider = ({ children }: Props) => {
  const [filterValue, setFilterValue] = useState<Optional<string>>()

  return <Provider value={{ filterValue, setFilterValue }}>{children}</Provider>
}

export { FPlusScopeFilterValueProvider }
